import React from 'react'
import '../../Styles/genelife.css';

export class Footer extends React.Component {
    render() {
        return (
            <footer>
            <div className="gl_footer">
              <div className="container">
       
                <div className="gl_footer_copy">
                  <div className="gl_footer_copy_logos">
                  <span className="site_logo"><a href="https://genelife.jp/"><img src={require("../../images/brand/site_logo.png")} alt="GeneLife"/></a></span>
                  <span className="copy">Copyright © Genesis Healthcare Co. All rights reserved.</span>
                  </div>
                  <div className="gl_footer_copy_menu spnone">
                    <ul>
                      <li><a href="https://genelife.jp/security.html">セキュリティについて</a></li>
                      <li><a href="https://genelife.jp/policy.html">プライバシーポリシー</a></li>
                    </ul>
                    <ul>
                      <li><a href="https://genelife.jp/tokushohou.html">特定商取引法に関する表示</a></li>
                      <li><a href="https://genelife.jp/disclaimer.html">免責事項</a></li>
                    </ul>
                    <ul>
                      <li><a href="https://genelife.jp/sitemap.html">サイトマップ</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )
    }
}

export default Footer;
